import styled from 'styled-components'



type IconProps = {
    color: string;
}

export const CloseIconContainer = styled.div<IconProps>`
    display:flex;
    justify-content: center;
    svg{
        fill: #999999;
    }
    svg:hover{
        cursor: pointer;
        fill: ${props => props.color};
        stroke: ${props => props.color};
        stroke-width: .55px;
    }
    
`